import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';
import { getAnalytics, logEvent, setUserId } from 'firebase/analytics';

@Injectable()
export class SharedCustomerService {
  private storageSub = new Subject<any>();

  watchStorage(): Observable<any> {
    return this.storageSub.asObservable();
  }

  updateAnalytics(eventName: string, eventParams?: { [key: string]: any }) {
    const analytics = getAnalytics();
    logEvent(analytics, eventName, eventParams);
    return;
  }
  updateUserIdentityAnalytics(userId: string) {
    const analytics = getAnalytics();
    setUserId(analytics, userId);
    return;
  }

  setItem(key: string, data: any) {
    localStorage.setItem(key, data);
    this.storageSub.next('changed');
  }

  removeItem(key) {
    localStorage.removeItem(key);
    this.storageSub.next('removed');
  }
}